import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const Scrollbar = () => {
  return (
    <div className="col-lg-12">
      <div className="header-menu">
        <ul className="smothscroll" style={{ listStyle: "none", padding: 0, margin: 0 }}>
          <li
            style={{
              position: "fixed",
              bottom: "25px",
              right: "25px",
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #0a2a6b, #3b82f6)", // dark blue → light blue
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 15px rgba(59, 130, 246, 0.4)",
              transition: "all 0.3s ease",
              cursor: "pointer",
              zIndex: 999,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "linear-gradient(135deg, #081f55, #2563eb)";
              e.currentTarget.style.transform = "scale(1.1)";
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.5)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "linear-gradient(135deg, #0a2a6b, #3b82f6)";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 15px rgba(59, 130, 246, 0.4)";
            }}
          >
            <AnchorLink href="#scrool" style={{ color: "#fff", fontSize: "20px", textDecoration: "none" }}>
              <i className="ti-arrow-up"></i>
            </AnchorLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Scrollbar;
